import React from 'react';
import { Form, Input, Tooltip } from '../../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';

export const DirectoryIdField = ({ value, onChange, required = true, disabled = false, error }) => {
    return (
        <Form.Item
            label={
                <span>
                    Directory ID{' '}
                    <Tooltip title="Provide your Azure Directory ID. This information can be obtained from the Azure Portal > Azure Active Directory > Properties.">
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            }
            validateStatus={error ? 'error' : ''}
            help={error}
            required={required}
        >
            <Input value={value || ''} onChange={onChange} disabled={disabled} placeholder="Enter Directory ID" />
        </Form.Item>
    );
};
